/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    authMainLayoutContainer: {
      display: 'flex',
      height: '100%',
      overflow: 'auto',
    },
    authMainLayoutDetails: {
      flex: 1,
      position: 'relative',
      paddingLeft: '5%',
    },
    authMainLayoutForm: {
      backgroundColor: theme.palette.secondary.light,
      flex: `0 0 ${theme.spacing(60)}px`,
      maxWidth: theme.spacing(60),
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    authMainLayoutFormContent: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    authMainLayoutFormMobile: {
      flex: `0 0 100%`,
      maxWidth: '100%',
    },
    authMainLayoutDetailsCont: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: theme.spacing(3),
      marginTop: '11.5%',
    },
    logoWrap: {
      marginBottom: theme.spacing(2),
    },
    logoOffset: {
      marginBottom: '-0.2rem', // algin text baseline
    },
    authBgImg: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'flex-start',
      },
      '& img': {
        width: '55%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    descList: {
      listStyleType: 'disc',
      marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    descListItem: {
      display: 'list-item',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  })
);
